module.exports = __webpack_public_path__ + "img/guatemala.74930aa2.svg";